module.exports = __webpack_public_path__ + "static/Product-Summary-Listen-Q3C-081dc96152919e0e4c11295d3ee0c9db.jpg";